import React, { useState } from 'react'
import { Cell, DataBlock, Divider, Expander, ExpanderContent, ExpanderHeader, Grid, H5 } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'

export default function OdmRecordBatch({ batch }) {
  const { t } = useTranslation()
  const [open, setOpen] = useState(true)

  const batchCollection = batch?.collection || '--'
  const batchNum = batch?.batchNumber || '--'
  const microFilmNum = batch?.microfile || '--'
  const batchTime = batch?.timePeriod || '--'
  const batchTemplateType = batch?.template || '--'
  const batchTemple = batch?.temple || '--'
  const batchDescription = batch?.description || '--'

  return (
    <>
      <Divider marginY="nano" />
      <Expander open={open} setOpen={setOpen}>
        <ExpanderHeader>
          <H5>{t('odm.batch', 'Batch Source Information')}</H5>
        </ExpanderHeader>
        <ExpanderContent>
          <Divider marginY="nano" />
          {batch && (
            <Grid>
              <Cell columns={1}>
                <DataBlock heading={t('odm.batch.collections', 'Collections')} data={batchCollection} />
              </Cell>
              <Cell columns={1}>
                <DataBlock heading={t('odm.batch.batchNumber', 'Batch #')} data={batchNum} />
              </Cell>
              <Cell columns={2}>
                <DataBlock heading={t('odm.batch.filmNumber', 'Micro Film #')} data={microFilmNum} />
              </Cell>
              <Cell columns={1}>
                <DataBlock heading={t('odm.batch.timePeriod', 'Time Period')} data={batchTime} />
              </Cell>
              <Cell columns={2}>
                <DataBlock heading={t('odm.batch.templateType', 'Template Type')} data={batchTemplateType} />
              </Cell>
              <Cell columns={2}>
                <DataBlock heading={t('odm.batch.temple', 'Temple')} data={batchTemple} />
              </Cell>
              <Cell columns={2}>
                <DataBlock heading={t('odm.batch.sourceDescription', 'Source Description')} data={batchDescription} />
              </Cell>
            </Grid>
          )}
          {!batch && <p>{t('odm.noBatch', 'No Batch Information')}</p>}
          <Divider marginY="nano" />
        </ExpanderContent>
      </Expander>
    </>
  )
}
